import { Avatar, Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react'
import { StandardTableActions } from '../../../Components/StandardTableActions/StandardTableActions';
import { DataTable } from '../../../Components/Table/DataTable';
import { IDataTableProps, MobileLogoRenderType, RenderType } from '../../../Components/Table/interfaces/IDataTableProps';
import { useAppSelector, IStoreState, useAppDispatch } from '../../../redux';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import { CustomButton } from '../../../Components/CustomButton';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { COMPANY_OUTLETS_ROUTE } from './CompanyOutlets.constants';
import { ICompanyOutlet, clearOutletsListSync, fetchOutletsListAsync } from '../../../redux/settings/outlets';

export const CompanyOutletsTable = () => {
    const {
        data: companyList,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.settings.outlets.outlets_list);
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const [pagination, setPagination] = React.useState({
        pageNumber: 1,
        rowsPerPage: 10,
    });


    const dataTableProps: IDataTableProps = {
        isPagination: true,
        rowsPerPageOptions: 25,
        isDataLoading: false,
        mobileLogo: {
            type: MobileLogoRenderType.reactNode,
            onMobileLogoRender: (data: any) => {
                return (
                    <Avatar
                        sx={{
                            width: 45,
                            height: 45,
                            color: "#fff",
                            ml: "-8px",
                            mr: 2,
                        }}
                    ></Avatar>
                );
            },
        },

        columns: [
            {
                key: "view",
                headerName: "Actions",
                fieldName: "",
                headingAlign: "center",
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (value, row: ICompanyOutlet) => {
                    return (
                        <StandardTableActions
                            onEditClick={() => navigate(`${COMPANY_OUTLETS_ROUTE}/manage/${row.outlet_uuid}`)}
                        />
                    );
                },
            },
            {
                key: "outlet_name",
                headerName: "Outlet Name",
                fieldName: "outlet_name",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "outlet_code",
                headerName: "Outlet Code",
                fieldName: "outlet_code",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "outlet_email",
                headerName: "Outlet Email",
                fieldName: "outlet_email",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "outlet_phone_number",
                headerName: "Phone Number",
                fieldName: "outlet_phone_number",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },

            {
                key: "outlet_opening_time",
                headerName: "Opening Time",
                fieldName: "outlet_opening_time",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (values, row: ICompanyOutlet) => {
                    return moment(row.outlet_opening_time).isValid() ? moment(row.outlet_opening_time).format("hh:mm A") : "--";
                },
            },
            {
                key: "outlet_closing_time",
                headerName: "Closing Time",
                fieldName: "outlet_closing_time",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (values, row: ICompanyOutlet) => {
                    return moment(row.outlet_closing_time).isValid() ? moment(row.outlet_closing_time).format("hh:mm A") : "--";
                },
            },
            {
                key: "company_logo",
                headerName: "Company Logo",
                fieldName: "",
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (value, row: ICompanyOutlet) => {
                    return (
                        <Button
                            variant="contained"
                        // onClick={() => setpenCustomizationOptionsDialog(row.customization_uuid)} 
                        >View Logo</Button>
                    );
                },
            },
        ],

        items: companyList,
        onPageChange: (newPageNumber: number) => {
            setPagination({ ...pagination, pageNumber: newPageNumber });
        },
        onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
            setPagination({
                pageNumber: pageNumber,
                rowsPerPage: rowsPerPage,
            });
        },
    };


    React.useEffect(() => {
        dispatch(
            fetchOutletsListAsync({
                page: pagination.pageNumber,
                rowsPerPage: pagination.rowsPerPage,
            }),
        );
    }, [pagination]);

    React.useEffect(() => {
        return () => {
            dispatch(clearOutletsListSync());
        };
    }, []);

    const isLightMode = useTheme().palette.mode === "light";

    return (
        <PageContainer title="Outlets" description='inner page' >
            <Stack direction="row" justifyContent="space-between" alignItems="center" my={2} >
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                    <Typography variant='h2'>Outlets</Typography>
                    {/* <ControlledCustomSelect
                        label="Search by Users"
                        options={[
                            { label: "All", value: "ALL" },
                        ]}
                        value={dateFilter}
                        onChange={(evt) => setDateFilter(evt.target.value as string)}
                        sx={{ minWidth: 120 }}
                        fullWidth size="small" />
                    <ControlledCustomSelect
                        label="Search by Date"
                        options={[
                            { label: "All", value: "ALL" },
                            { label: "Today", value: moment().format("yyyy-MM-DD") },
                            { label: "Yesterday", value: moment().subtract(1, "day").format("yyyy-MM-DD") },
                            { label: "Custom", value: "CUSTOM" },
                        ]}
                        value={dateFilter}
                        onChange={(evt) => setDateFilter(evt.target.value as string)}
                        sx={{ minWidth: 120 }}
                        fullWidth size="small" />

                    {customDateDialog && <CustomDatePicker
                        label="Select Date"
                        fullWidth
                        fieldName="reservation_date"
                        value={customDate || ""}
                        onChange={(newValue, formattedDate) => {
                            setCustomDate(formattedDate);
                        }}
                    />} */}
                </Stack>
                <CustomButton
                    variant="outlined"
                    color="primary"
                    sx={{
                        display: "flex",
                        marginLeft: "auto",
                        marginY: 2,
                        minWidth: "80px !important",
                        backgroundColor: isLightMode
                          ? "var(--secondary-color)"
                          : "var(--primary-color)",
                        color: isLightMode
                          ? "var(--text-light-color)"
                          : "var(--text-dark-color)",
                        border: isLightMode
                          ? "var(--border-light-color) 1px solid"
                          : "var(--border-dark-color) 1px solid",
                        "&:hover": {
                          backgroundColor: isLightMode
                            ? "var(--secondary-color)"
                            : "var(--tertiary-color)",
                          opacity: isLightMode ? 0.85 : 1,
                          // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                          border: isLightMode
                            ? "var(--border-light-color) 1px solid"
                            : "var(--border-dark-color) 1px solid",
                        },
                      }}
                    onClick={() => navigate(`${COMPANY_OUTLETS_ROUTE}/manage`)}
                >
                    Add New Outlet
                </CustomButton>
            </Stack>
            <DataTable {...dataTableProps} />
        </PageContainer>
    );
}
